e4.handlebars = {
    tmpl: {},
    registerTemplates: function ( strTemplates ) {
        var arrTemplates = strTemplates.split( ' ' );
        for ( var i = 0; i < arrTemplates.length; i++ ) {
            if ( jQuery( arrTemplates[ i ] ).length === 1 ) {
                var tmplName = arrTemplates[ i ].replace( '#js-e-handlebars-tmpl-', '' ).replace( /-([a-z])/g, function ( strFirstLetter ) {
                    return strFirstLetter[ 1 ].toUpperCase();
                } );
                e4.handlebars.tmpl[ tmplName ] = Handlebars.compile( jQuery( arrTemplates[ i ] ).html() );
            }
        }
    },
    partial: {},
    registerPartials: function ( strPartials ) {
        var arrPartials = strPartials.split( ' ' );
        for ( var i = 0; i < arrPartials.length; i++ ) {
            if ( jQuery( arrPartials[ i ] ).length === 1 ) {
                var partialName = arrPartials[ i ].replace( '#js-e-handlebars-partial-', '' ).replace( /-([a-z])/g, function ( strFirstLetter ) {
                    return strFirstLetter[ 1 ].toUpperCase();
                } );
                Handlebars.registerPartial( partialName, jQuery( arrPartials[ i ] ).html() );
                e4.handlebars.partial[ partialName ] = Handlebars.compile( jQuery( arrPartials[ i ] ).html() );
            }
        }
    },
    registerHelpers: function ( strHelpers ) {
        var arrHelpers = strHelpers.split( ' ' );
        for ( var i = 0; i < arrHelpers.length; i++ ) {
            if ( window.Handlebars.helpers[ arrHelpers[ i ] ] === undefined ) {
                e4.handlebars.helpers[ arrHelpers[ i ] ]();
            }
        }
    },
    helpers: {
        testValue: function ( v1, operator, v2 ) {
            switch ( operator ) {
                case '===':
                    return ( v1 === v2 );
                case '!==':
                    return ( v1 !== v2 );
                case '<':
                    return ( v1 < v2 );
                case '<=':
                    return ( v1 <= v2 );
                case '>':
                    return ( v1 > v2 );
                case '>=':
                    return ( v1 >= v2 );
                case '&&':
                    return ( v1 && v2 );
                case '||':
                    return ( v1 || v2 );
                case '!!':
                    return ( !v1 && !v2 );
                case '!|':
                    return ( !v1 && v2 );
                case '|!':
                    return ( v1 && !v2 );
                case '%':
                    return ( v1 % v2 === 0 );
                default:
                    return false;
            }
        },
        compare_extended: function () {
            Handlebars.registerHelper( 'compare_extended', function ( v1, operator, v2, options ) {
                if ( v2.indexOf( ',' ) > -1 ) {
                    // v2 is array - extend compare-function
                    var v2Arr = v2.split( ',' ),
                        v2ReturnArr = [];
                    // iterate v2-array and test each value, adding the returned boolean to a temp array
                    for ( var i = 0; i < v2Arr.length; i++ ) {
                        v2ReturnArr.push( e4.handlebars.helpers.testValue( v1, operator, v2Arr[ i ] ) );
                    }
                    // test temp array values, returning true if all values are the same, eg. [true,true] or
                    // [false,false]
                    return v2ReturnArr.every( function ( val ) {
                        return val;
                    } ) === true ? options.fn( this ) : options.inverse( this );
                }
                else {
                    // v2 is string - standard compare function
                    return e4.handlebars.helpers.testValue( v1, operator, v2 ) ? options.fn( this ) : options.inverse( this );
                }
            } );
        },
        compare: function () {
            Handlebars.registerHelper( 'compare', function ( v1, operator, v2, options ) {
                switch ( operator ) {
                    case '===':
                        return ( v1 === v2 ) ? options.fn( this ) : options.inverse( this );
                    case '!==':
                        return ( v1 !== v2 ) ? options.fn( this ) : options.inverse( this );
                    case '<':
                        return ( v1 < v2 ) ? options.fn( this ) : options.inverse( this );
                    case '<=':
                        return ( v1 <= v2 ) ? options.fn( this ) : options.inverse( this );
                    case '>':
                        return ( v1 > v2 ) ? options.fn( this ) : options.inverse( this );
                    case '>=':
                        return ( v1 >= v2 ) ? options.fn( this ) : options.inverse( this );
                    case '&&':
                        return ( v1 && v2 ) ? options.fn( this ) : options.inverse( this );
                    case '||':
                        return ( v1 || v2 ) ? options.fn( this ) : options.inverse( this );
                    case '!!':
                        return ( !v1 && !v2 ) ? options.fn( this ) : options.inverse( this );
                    case '!|':
                        return ( !v1 && v2 ) ? options.fn( this ) : options.inverse( this );
                    case '|!':
                        return ( v1 && !v2 ) ? options.fn( this ) : options.inverse( this );
                    case '%':
                        return ( v1 % v2 === 0 ) ? options.fn( this ) : options.inverse( this );
                    default:
                        return options.inverse( this );
                }
            } );
        },
        counter: function () {
            Handlebars.registerHelper( 'counter', function ( index ) {
                return index + 1;
            } );
        },
        loop: function () {
            Handlebars.registerHelper( 'loop', function ( items, options ) {
                var out = '';
                for ( var i = 0, l = items.length; i < l; i++ ) {
                    out = out + options.fn( items[ i ] );
                }
                return out;
            } );
        },
        encoder: function () {
            Handlebars.registerHelper( 'encoder', function ( str ) {
                return encodeURIComponent( str );
            } );
        },
        json: function () {
            Handlebars.registerHelper( 'json', function ( context ) {
                return JSON.stringify( context );
            } );
        },
        compareLength: function () {
            Handlebars.registerHelper( 'compareLength', function ( arr, operator, v2, options ) {
                var v1 = arr.length;
                return e4.handlebars.helpers.testValue( v1, operator, v2 ) ? options.fn( this ) : options.inverse( this );
            } );
        },
        hasCategories: function () {
            Handlebars.registerHelper( 'hasCategories', function ( categories, options ) {
                var hasCategories = false;
                Object.keys( categories ).filter( function ( key ) {
                    var hasCategory = categories[ key ].parts.filter( function ( part ) {
                        return part.isDefault === true;
                    } ).length === 0;
                    if ( hasCategory ) {
                        hasCategories = true;
                    }
                } );
                return hasCategories ? options.fn( this ) : options.inverse( this );
            } );
        },
        isNotDefaultPartInCategory: function () {
            Handlebars.registerHelper( 'isNotDefaultPartInCategory', function ( category, options ) {
                var shouldShowCategoty = category.parts.filter( function ( part ) {
                    return part.isDefault === true;
                } ).length === 0;
                return shouldShowCategoty ? options.fn( this ) : options.inverse( this );
            } );
        },
        grouped_each: function () {
            Handlebars.registerHelper( 'grouped_each', function ( every, context, options ) {
                var out = '',
                    subcontext = [],
                    i;
                if ( context && context.length > 0 ) {
                    for ( i = 0; i < context.length; i++ ) {
                        if ( i > 0 && i % every === 0 ) {
                            out += options.fn( subcontext );
                            subcontext = [];
                        }
                        subcontext.push( context[ i ] );
                    }
                    out += options.fn( subcontext );
                }
                return out;
            } );
        },
        getCustomOsLanguagePartName: function () {
            Handlebars.registerHelper( 'getCustomOsLanguagePartName', function () {
                return jQuery( '.js-dcc-configurator-overview-custom-os-language' ).val();
            } );
        },
        filterConfigurationParts: function () {
            Handlebars.registerHelper( 'filterConfigurationParts', function ( part, key, options ) {
                if ( !part || part.length === 0 ) {
                    return options.inverse( this );
                }
                if ( key === 'oslanguage' ) {
                    if ( part.number === part.osLang ) {
                        return options.inverse( this );
                    }
                }
                return options.fn( this );
            } );
        },
        filterKeyboardLanguages: function () {
            Handlebars.registerHelper( 'filterKeyboardLanguages', function ( languagesArr, options ) {
                if ( !languagesArr || languagesArr.length === 0 ) {
                    return options.inverse( this );
                }
                var uniqueLanguageArr = [],
                    result = [];
                languagesArr = languagesArr.sort( function ( a, b ) {
                    if ( a.isDefault === b.isDefault ) {
                        var langA = a.keyboardLang.toUpperCase(),
                            langB = b.keyboardLang.toUpperCase();
                        return ( langA < langB ) ? -1 : ( langA > langB ) ? 1 : 0;
                    }
                    return b.isDefault - a.isDefault;
                } );
                for ( var i = 0; i < languagesArr.length; ++i ) {
                    var languageObj = languagesArr[ i ],
                        uniqueIndex = uniqueLanguageArr.indexOf( languageObj.keyboardLang );
                    if ( uniqueIndex === -1 ) {
                        if ( languageObj.keyboardLang !== '' ) {
                            uniqueLanguageArr.push( languageObj.keyboardLang );
                            result.push( options.fn( languageObj ) );
                        }
                    }
                    else if ( languageObj.isDefault === true ) {
                        uniqueLanguageArr[ uniqueIndex ] = languageObj;
                        result[ uniqueIndex ] = options.fn( languageObj );
                    }
                }
                return result;
            } );
        },
        getKeyboardDiffPrice: function () {
            Handlebars.registerHelper( 'getKeyboardDiffPrice', function ( languagesArr ) {
                var result = 0;
                for ( var i = 0; i < languagesArr.length; ++i ) {
                    var languageObj = languagesArr[ i ];
                    if ( languageObj.price > 0 && languageObj.isDefault === false ) {
                        result = languageObj.price;
                        break;
                    }
                }
                return e4.util.formatJavascriptNumberToLocaleString( result );
            } );
        }
    }
};

